<template>
    <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible">

        <el-form :model="obj" ref="addEditForm" status-icon :rules="rules">
            <el-tabs v-model="activeName">
                <!-- Algemeen -->
                <el-tab-pane label="Algemeen" name="meta" class="p-1">
                    <div class="mt-2">
                        <el-row :gutter="10">
                            <el-col :span="18">
                                <el-form-item prop="name">
                                    <el-tooltip class="item" effect="dark" content="Interne naam voor de tak"
                                                placement="top">
                                        <el-input placeholder="Naam" v-model="obj.name"
                                                  prefix-icon="el-icon-medal"></el-input>
                                    </el-tooltip>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item prop="sticky">
                                    <el-tooltip class="item" effect="dark" content="Tak is een pseudo" placement="top">
                                        <el-checkbox v-model="obj.isPseudo" label="Pseudo" border class="w-full"></el-checkbox>
                                    </el-tooltip>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col>
                                <el-form-item prop="sponsors">
                                    <el-tooltip class="item" effect="dark"
                                                content="Sponsors van de tak" placement="top">
                                        <el-select v-model="obj.sponsorIds"
                                                   placeholder="Sponsors"
                                                   multiple
                                                   class="w-full">
                                            <span slot="prefix"><i class="el-icon-wallet pl-1"></i></span>
                                            <el-option
                                                    v-for="item in sponsorOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-tooltip>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-form-item prop="isActive">
                                <el-col>
                                    <el-tooltip class="item" effect="dark"
                                                content="Inschrijvingen voor deze tak worden geaccepteerd"
                                                placement="top">
                                        <el-switch
                                                v-model="obj.isActive"
                                                active-text="Actief"
                                                inactive-text="Inactief"
                                                :disabled="obj.isPseudo">
                                        </el-switch>
                                    </el-tooltip>
                                </el-col>
                            </el-form-item>
                        </el-row>
                    </div>
                </el-tab-pane>

                <!-- Content -->
                <el-tab-pane label="Preview" name="frontpage" class="p-1">
                    <div class="mt-2">
                        <el-row :gutter="10">
                            <el-col :span="24">
                                <el-form-item prop="title">
                                    <el-tooltip class="item" effect="dark" content="Titel weergegeven bij preview"
                                                placement="top">
                                        <el-input placeholder="Titel" v-model="obj.title"></el-input>
                                    </el-tooltip>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="24">
                                <el-form-item prop="shortDescription">
                                    <el-tooltip class="item" effect="dark"
                                                content="Beschrijving weergegeven bij preview" placement="top">
                                        <text-editor ref="textEditorRef" v-model="obj.shortDescription" :current="obj.shortDescription"></text-editor>
                                    </el-tooltip>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>

                <!-- Content -->
                <el-tab-pane label="Content" name="details" class="p-1" :disabled="obj.isPseudo">
                    <el-row :gutter="10">
                            <el-form-item prop="fullDescription">
                                <el-tooltip class="item" effect="dark"
                                            content="Gedetailleerde beschrijving weergegeven op takpagina" placement="top">
                                    <text-editor ref="textEditorRef" v-model="obj.fullDescription" :current="obj.fullDescription"></text-editor>
                                </el-tooltip>
                            </el-form-item>
                    </el-row>
                </el-tab-pane>

                <!-- Inschrijvingen -->
                <el-tab-pane label="Inschrijvingen" name="enrollments" :disabled="!obj.isActive || obj.isPseudo" class="p-1">
                    <div class="mt-2">
                        <el-row :gutter="10">
                            <el-col :span="24">
                                <el-form-item prop="accountNumber">
                                    <el-tooltip class="item" effect="dark" content="Rekeningnummer inschrijvingen" placement="top">
                                        <el-input placeholder="Rekeningnummer" v-model="obj.enrollmentAccountNumber"
                                                prefix-icon="el-icon-bank-card"></el-input>
                                    </el-tooltip>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10">
                            <el-col :span="24">
                                <el-form-item prop="enrollmentPrice">
                                    <el-tooltip class="item" effect="dark"
                                                content="Kost inschrijven voor tak" placement="top">
                                        <el-input
                                                placeholder="Inschrijvingsgeld"
                                                v-model="obj.enrollmentPrice"
                                                prefix-icon="el-icon-money"
                                                type="number">
                                            <template slot="append">EUR</template>
                                        </el-input>
                                    </el-tooltip>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="10">
                            <el-col :span="24">
                                <el-form-item prop="enrollmentNote">
                                    <el-tooltip class="item" effect="dark"
                                                content="Extra informatie die weergegeven wordt bij de inschrijving"
                                                placement="top">
                                        <el-input type="textarea"
                                                  v-model="obj.annotation"
                                                  placeholder="Extra informatie"
                                                  maxlength="120"
                                                  show-word-limit></el-input>
                                    </el-tooltip>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-form>

        <!-- Footer -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Annuleer</el-button>
            <el-button type="primary" @click="submitForm('addEditForm')" :loading="loading">Opslaan</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import TextEditor from "../../forms/TextEditor";

    export default {
        name: "BranchDialog",
        props: ["sponsorOptions"],
        components: {
            TextEditor
        },
        data() {
            return {
                dialogTitle: "",
                itemName: "Tak",
                dialogVisible: false,
                adding: false,
                obj: this.getEmptyObject(),
                loading: false,
                activeName: "meta",

                // Rules
                rules: {
                    name: [
                        {required: true, message: 'Vul een naam in.', trigger: 'blur'}
                    ],
                    title: [
                        {required: true, message: 'Vul een titel in.', trigger: 'blur'}
                    ],
                    shortDescription: [
                        {required: true, message: 'Vul een korte beschrijving in.', trigger: 'blur'}
                    ],
                    fullDescription: [
                        {required: false, message: 'Vul een volledige beschrijving in.', trigger: 'blur'}
                    ],
                },
            }
        },
        methods: {
            edit(obj) {
                this.dialogTitle = `${this.itemName} wijzigen`
                this.dialogVisible = true
                this.adding = false
                this.obj = JSON.parse(JSON.stringify(obj));
                //this.$refs["textEditorRef"].setContent(JSON.parse(obj.fullDescription))
                this.reset()
            },
            add() {
                this.dialogTitle = `${this.itemName} toevoegen`
                this.dialogVisible = true
                this.adding = true
                this.obj = this.getEmptyObject()
                //this.$refs["textEditorRef"].setContent(this.obj.fullDescription)
                this.reset()
            },
            reset() {
                if(this.$refs['addEditForm']) {
                    this.$refs['addEditForm'].resetFields()
                }
                this.activeName = "meta"
            },
            getEmptyObject() {
                return {
                    // Form data
                    name: "",
                    title: "",
                    isActive: false,
                    isPseudo: false,
                    shortDescription: "",
                    fullDescription: null,
                    sponsorIds: [],
                    enrollmentPrice: null,
                    enrollmentAccountNumber: null,
                    annotation: ""
                }
            },
            submitForm(formName) {
                // Submit form
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        if (this.adding) {
                            this.$parent.objAdded(this.obj);
                        } else {
                            this.$parent.objEdited(this.obj);
                        }
                    } else {
                        this.openAlert('Gelieve alle informatie correct in te vullen.', 'error')
                        return false;
                    }
                });
            },
            close() {
                this.loading = false;
                this.dialogVisible = false;
            },
            openAlert(msg, type) {
                this.$message({
                    showClose: true,
                    message: msg,
                    type: type
                });
                return false;
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/dashboard/branches/dialogs/BranchDialog.vue